import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {NgbCalendar, NgbDate, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {defaultDateFormat} from '../utils/constants';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateInputComponent implements OnInit, OnChanges {

  @Input() model = '';
  @Input() field: any = {};
  @Input() ngClass: any = {};
  @Input() disabled: boolean;
  @Input() placeholder: string;
  @Input() label: string = '';
  @Input() required: boolean = false;
  // Форма передаёт сюда field.minDate/field.maxDate, которые у большинства
  // полей undefined (или строка "дд.мм.гггг" из fieldsValue) — без фолбэка
  // ngb-datepicker сужает список годов до ±10 от текущего.
  private static readonly DEFAULT_MIN_DATE: NgbDateStruct = { day: 1, month: 1, year: 1900 };
  private static readonly DEFAULT_MAX_DATE: NgbDateStruct = { day: 31, month: 12, year: 2100 };

  private _maxDate: NgbDateStruct = DateInputComponent.DEFAULT_MAX_DATE;
  private _minDate: NgbDateStruct = DateInputComponent.DEFAULT_MIN_DATE;

  @Input() set maxDate(value: NgbDateStruct | string) {
    this._maxDate = this.toDateStruct(value) || DateInputComponent.DEFAULT_MAX_DATE;
  }
  get maxDate(): NgbDateStruct {
    return this._maxDate;
  }

  @Input() set minDate(value: NgbDateStruct | string) {
    this._minDate = this.toDateStruct(value) || DateInputComponent.DEFAULT_MIN_DATE;
  }
  get minDate(): NgbDateStruct {
    return this._minDate;
  }
  @Output() onDateChange = new EventEmitter();
  public date: NgbDate;
  public isFocused: boolean = false;

  constructor(
    private calendar: NgbCalendar
  ) { }

  get hasValue(): boolean {
    return !!(this.date && this.date.year && this.date.month && this.date.day);
  }

  ngOnInit() {
    this.updateDate(this.model);
    // Set label from field if not provided
    if (!this.label && this.field && this.field.title) {
      // Will be set from parent component
    }
    if (this.required === undefined && this.field && this.field.mandatory !== undefined) {
      this.required = this.field.mandatory;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model) {
      this.updateDate(changes.model.currentValue);
    }
  }

  isDisabled = (date: NgbDate, current: {month: number}) => date.month !== current.month;
  isWeekend = (date: NgbDate) =>  this.calendar.getWeekday(date) >= 6;

  private toDateStruct(value: NgbDateStruct | string): NgbDateStruct | null {
    if (!value) {
      return null;
    }
    if (typeof value === 'string') {
      const parsed = moment(value, defaultDateFormat, true);
      return parsed.isValid()
        ? { day: parsed.date(), month: parsed.month() + 1, year: parsed.year() }
        : null;
    }
    return value.year ? value : null;
  }

  updateDate(model) {
    if (model === null || model === undefined || model === '') {
      this.date = null;
      return;
    }

    const parsed = moment(model, defaultDateFormat, true);
    if (parsed.isValid()) {
      const formatted = parsed.format(defaultDateFormat).split('.');
      this.date = new NgbDate(+formatted[2], +formatted[1], +formatted[0]);
    } else {
      this.date = null;
    }
  }

  onChange(event) {
    this.onDateChange.emit({
      val: event ? `${this.addZero(event.day)}.${this.addZero(event.month)}.${event.year}` : '',
      date: event
    });
  }

  onFocus() {
    this.isFocused = true;
  }

  onBlur() {
    this.isFocused = false;
  }

  addZero = (num) => (num < 10 ? `0${num}` : num);

}
